import { render, staticRenderFns } from "./dynamic-submodule-2.vue?vue&type=template&id=52e4b79e&"
import script from "./dynamic-submodule-2.vue?vue&type=script&lang=js&"
export * from "./dynamic-submodule-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports